import { ReminderTopic } from './ReminderTopic';

export class ReminderUpdateDTO {
  id: number;
  isPersonal: boolean;
  deadline: Date;
  reminderDate: Date;
  topic: ReminderTopic;
  description?: string;
  isCompleted: boolean;
  fundUUID?: string;

  constructor(id: number, isPersonal: boolean, deadline: Date, reminderDate: Date,
    topic: ReminderTopic | string, description: string, isCompleted: boolean, fundUUID?: string) {
    this.id = id;
    this.isPersonal = isPersonal;
    this.deadline = deadline;
    this.reminderDate = reminderDate;
    this.topic = ReminderTopic[topic];
    this.description = description;
    this.isCompleted = isCompleted;
    this.fundUUID = fundUUID;
  }
}
